<div class="modal-container-content" tabindex="0">
  <ul>
    <li>
      <span>Factuurdatum:</span>
      <span>{{ invoice.invoice_date | date: 'dd-MM-yyyy' }}</span>
    </li>
    <li>
      <span>Factuurbedrag:</span>
      <span><app-currency [value]="invoice.amount_incl"/></span>
    </li>
    <li>
      <span>Status:</span>
      <span><app-payment-status [isPaid]="invoice.is_paid"/></span>
    </li>
    <li>
      <span>Betaalwijze:</span>
      <span>{{ invoice.payment_type | titlecase }}</span>
    </li>
    <li>
      <span>Betreft:</span>
      <span>{{ invoice.description }}</span>
    </li>
  </ul>

  <table>
    <thead>
      <tr>
        <th scope="col">Omschrijving</th>
        @if ((mobileService.isMobile() | async) === false) {
          <th scope="col">Periode</th>
        }
        <th scope="col">Prijs ({{ isBusiness ? 'excl.' : 'incl.' }} BTW)</th>
      </tr>
    </thead>
    <tbody>
      @for (item of invoice.lines; track item) {
        <tr>
          <td>{{ item.description }}</td>
          @if ((mobileService.isMobile() | async) === false) {
            <td>{{ item.period }}</td>
          }
          <td>
            <app-currency [value]="item.amount"/>
          </td>
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        @if ((mobileService.isMobile() | async) === false) {
          <td rowspan="3">
            @if (!invoice.is_paid) {
              Resterende bedrag overmaken naar rekeningnummer {{ this.config.bank_account }}, onder vermelding van
              het factuurnummer {{ invoice.invoice_number }}
            }
          </td>
        }
        <th scope="row">
          Totaal excl. BTW
        </th>
        <td>
          <app-currency [value]="invoice.amount_excl"/>
        </td>
      </tr>
      <tr>
        <th scope="row">
          BTW 21%
        </th>
        <td>
          <app-currency [value]="invoice.amount_btw"/>
        </td>
      </tr>
      <tr>
        <th scope="row">
          Totaal incl. BTW
        </th>
        <td>
          <app-currency [value]="invoice.amount_incl"/>
        </td>
      </tr>
    </tfoot>
  </table>

  @if ((!this.invoice.is_paid && (this.mobileService.isMobile() | async))) {
    <p>
      Resterende bedrag overmaken naar rekeningnummer {{ this.config.bank_account }}, onder vermelding van het
      factuurnummer {{ invoice.invoice_number }}
    </p>
  }
</div>

<div class="modal-container-footer">
  <app-button (click)="this.download()">Downloaden</app-button>
</div>
